"use client";

import { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { trackFailure } from "@/lib/integrations/sentry-tracking";

export function NotFound() {
  const { t } = useTranslation();
  const location = useLocation();

  useEffect(() => {
    let referrerOrigin = "";
    if (typeof document !== "undefined" && document.referrer) {
      try {
        referrerOrigin = new URL(document.referrer).origin;
      } catch {
        referrerOrigin = "";
      }
    }
    trackFailure("navigation", "route_not_found", {
      path: location.pathname,
      referrer_origin: referrerOrigin,
    });
  }, [location.pathname]);

  return (
    <main className="flex min-h-screen items-center justify-center">
      <div className="text-center">
        <h1 className="text-6xl font-bold">404</h1>
        <p className="mt-4 text-lg text-muted-foreground">
          {t("ERROR.PAGE_NOT_FOUND")}
        </p>
        <Link
          to="/"
          className="mt-6 inline-block rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground hover:opacity-90"
        >
          {t("ACTION.GO_HOME")}
        </Link>
      </div>
    </main>
  );
}
